export default __webpack_public_path__ + "static/media/parallax_back.810a5203.webp";